import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import {IMonthlyWeightShipped} from "./MonthlyWeightShipped.types";

export default class MonthlyWeightShippedApi {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/MonthlyWeightShipped`, {params: rawQuery});
            return res.data as IWidgetResponse<IMonthlyWeightShipped>;
        } catch (e: any) {
            console.error('Could not get MonthlyWeightShipped data: ', e.message);
            return undefined;
        }
    }
}